import styled from "@emotion/styled";
import { HEADER_STICKY_OFFSET } from "src/utils/constants";

export const FacetsContainer = styled.div`
  position: sticky;
  top: ${HEADER_STICKY_OFFSET}px;
  display: flex;
  gap: ${({ theme }) => theme.space?.space16};
  background-color: ${({ theme }) => theme.colors?.tone.white};
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    position: static;
    padding-block: 0;
    margin-top: 0;
    overflow: visible;
  }
`;

export const StatsWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: ${({ theme }) => theme.space?.space32};
  align-items: center;
  gap: ${({ theme }) => theme.space?.space4};
  justify-content: space-between;
`;

export const FilterButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: flex;
    align-items: center;
  }
`;

export const SortStatsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space?.space16};
  margin-left: auto;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    gap: ${({ theme }) => theme.space?.space8};
  }
`;

export const ResetAllFilters = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes?.fontSize16};
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors?.tone.black};
  white-space: nowrap;
`;

export const DesktopFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  gap: ${({ theme }) => theme.space?.space16};
`;

export const CollectionsRowWrapper = styled.div`
  position: sticky;
  top: ${HEADER_STICKY_OFFSET}px;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: ${({ theme }) => theme.space?.space16};
  padding-block: ${({ theme }) => theme.space?.space24};
  margin-top: -${({ theme }) => theme.space?.space24};
  background-color: ${({ theme }) => theme.colors?.tone.white};
  z-index: 100;

  ${FacetsContainer} {
    position: static;
    flex: 1;
    min-width: 0;
    padding-block: 0;
    margin-top: 0;
    overflow: hidden;
  }
`;

export const MobileTitleContainer = styled.div`
  display: none;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: block;
  }

  .formatted-title::before {
    content: "“";
  }

  .formatted-title::after {
    content: "”";
  }
`;

export const FiltersWrapper = styled.div`
  flex: 1 1 0%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`;
